import { useLanguage } from '@/hooks/useLanguage';
import { FiHelpCircle } from 'react-icons/fi';
import { useAppTour } from './useAppTour';

interface TourReplayButtonProps {
  className?: string;
  iconSize?: number;
}

export function TourReplayButton({ className = '', iconSize = 20 }: TourReplayButtonProps) {
  const { t } = useLanguage();
  const { startTour } = useAppTour();

  const handleClick = () => {
    startTour({ skipWelcome: true });
  };

  return (
    <button
      type="button"
      className={`tour-replay-button ${className}`.trim()}
      onClick={handleClick}
      aria-label={t('appTour.replayButton')}
      title={t('appTour.replayButton')}
    >
      <FiHelpCircle size={iconSize} aria-hidden="true" />
    </button>
  );
}
